import { render, staticRenderFns } from "./caches.vue?vue&type=template&id=5663553f&scoped=true"
import script from "./caches.vue?vue&type=script&lang=js"
export * from "./caches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663553f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5663553f')) {
      api.createRecord('5663553f', component.options)
    } else {
      api.reload('5663553f', component.options)
    }
    module.hot.accept("./caches.vue?vue&type=template&id=5663553f&scoped=true", function () {
      api.rerender('5663553f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/caches/caches.vue"
export default component.exports